



























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ModalBoxAdvanced extends Vue {
  @Prop({ default: "680px" }) readonly width!: string;
  @Prop({ default: true }) readonly clickOutside!: boolean;
  @Prop({ default: true }) readonly isOpenIconClose!: boolean;

  private scrollTop = false;
  private overFooter = 0;
  private scrollBottom = true;
  private boxHeight = 0;
  private toggleModalBoxOverFlow = "";
  private keyCodeESC = 27;

  get hasHeaderSlot() {
    return !!this.$slots["header"];
  }
  get hasFooterSlot() {
    return !!this.$slots["footer"];
  }

  created() {
    this.ToggleBodyOverFlow("hidden");
  }

  mounted() {
    this.HandleScroll();
    document.addEventListener("keydown", this.HandlerKey);
    document.addEventListener("mousemove", this.SetBoxHeight);
    const refModalBox: any = this.$refs.modalBox;
    refModalBox.addEventListener("scroll", this.HandleScroll);
    setTimeout(() => {
      this.SetBoxHeight();
    }, 250);
    this.$emit("mounted");
  }

  beforeDestroy() {
    this.ToggleBodyOverFlow("auto");
    document.removeEventListener("keydown", this.HandlerKey);
    document.removeEventListener("mousemove", this.SetBoxHeight);
    const refModalBox: any = this.$refs.modalBox;
    refModalBox.removeEventListener("scroll", this.HandleScroll);
  }

  public SetBoxHeight() {
    const refModalBox: any = this.$refs.modalBox;
    this.boxHeight = refModalBox.clientHeight;
    this.ToggleModalBoxOverFlow();
  }

  public HandleScroll() {
    const refModalBox: any = this.$refs.modalBox;
    const refModalBoxFooter: any = this.$refs.modalBoxFooter;
    const refModalBoxHeader: any = this.$refs.modalBoxHeader;
    const refModalBoxBody: any = this.$refs.modalBoxBody;
    if (refModalBoxBody && refModalBoxHeader && refModalBoxFooter && refModalBox) {
      this.scrollTop = refModalBox.scrollTop > 0;
      this.scrollBottom =
        refModalBoxBody.offsetHeight +
          refModalBoxHeader.offsetHeight +
          refModalBoxFooter.offsetHeight -
          (refModalBox.offsetHeight + refModalBox.scrollTop) <
        5;
    }
  }

  public ToggleBodyOverFlow(overflowType: string) {
    const el = document.body;
    el.style.overflow = overflowType;
  }

  public ToggleModalBoxOverFlow() {
    if (!this.scrollTop && this.scrollBottom) {
      this.toggleModalBoxOverFlow = "";
    } else {
      this.toggleModalBoxOverFlow = "importantOverFlowAuto";
    }
  }

  public HandlerKey(e: any) {
    if (this.isOpenIconClose) {
      if (e.keyCode == this.keyCodeESC) {
        this.$emit("update:showModal", false);
      }
    }
  }

  public hide(e: any, el: any) {
    if (e.target.id == "modalBox" && this.clickOutside) {
      this.$emit("update:showModal", false);
    }
  }
}
